<template>
    <div>
        <a-spin :spinning="dataLoading">
            <div class="container">
                <div class="left">
                    <a-descriptions title="工作列表">
                        <a-descriptions-item>
                            <a-list size="default" item-layout="horizontal" :data-source="listData" :loading="dataLoading">
                                <a-list-item slot="renderItem" slot-scope="item">
                                    <a-list-item-meta>
                                        <div slot="title">
                                            <a class="home-list-item-title-a" @click="toPage(item.fun_entry)">
                                                <a-icon type="alert" style="font-size: 18px;" />
                                                {{ item.message_lable }}
                                            </a>
                                        </div>
                                    </a-list-item-meta>
                                </a-list-item>
                            </a-list>
                        </a-descriptions-item>
                    </a-descriptions>
                </div>
                <div class="right">
                    <a-descriptions title="通知列表">
                        <a-descriptions-item>
                            <a-list size="default" item-layout="horizontal" :data-source="noticeData" :loading="dataLoading">
                                <a-list-item slot="renderItem" slot-scope="item">
                                    <a-list-item-meta>
                                        <div slot="title">
                                            <a class="home-list-item-title-a" @click="toPage(item.fun_entry, item.p2)">
                                                <a-icon type="bell" style="font-size: 18px;" />
                                                {{ item.message_lable }}
                                            </a>
                                        </div>
                                    </a-list-item-meta>
                                </a-list-item>
                            </a-list>
                        </a-descriptions-item>
                    </a-descriptions>
                </div>
            </div>
        </a-spin>
    </div>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
const { mapActions } = createNamespacedHelpers("user");
export default {
    name: "Home",
    components: {},
    data() {
        return {
            dataLoading: false,
            queryParams: {},
            noticeData: [],
            listData: []
        };
    },
    computed: {},
    created() {
        this.loadListData();
    },
    mounted() {},
    methods: {
        ...mapActions(["setNoticeId"]),
        toPage(funEntry, id) {
            if (id) {
                this.setNoticeId(id);
            }
            this.$router.push(funEntry);
        },
        loadListData(type) {
            this.noticeData = [];
            this.listData = [];
            this.$FG_http
                .post(
                    "./api/notice/listNotice",
                    {
                        type: type
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    if (success) {
                        if (data.data) {
                            // 设置当前数据
                            data.data.forEach((item) => {
                                if (item.type === 1) {
                                    this.listData.push(item);
                                } else {
                                    this.noticeData.push(item);
                                }
                            });
                        } else {
                            // 加载的数据不存在
                            this.$FG_message.error("P0002").then(() => (this.listData = []));
                        }
                    } else {
                        // 加载数据出错或没有加载到数据则返回列表
                        this.listData = [];
                    }
                });
        }
    },
    beforeDestroy() {}
};
</script>
<style lang="scss" scoped>
.container {
    display: flex;
    margin: 10px;
    padding: 10px;
    height: calc(100vh - 70px);
    overflow: auto;
    background: #fff;
}
.home-list-item-title-a {
    color: #03a9f4;
    font-size: 15px;
}
.home-list-item-title-a:hover {
    color: red;
}
::v-deep .ant-list-item {
    padding: 0;
    margin: 10px 0;
}
</style>
